import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  // BreadcrumbLink,
  Container,
  Heading,
  Stack,
  Text,
  Button as ChakraButton,
  VStack,
  HStack,
  OrderedList,
  ListItem,
  useDisclosure,
  ChakraProvider,
  CircularProgress,
  useToast,
  Image,
  FormControl,
} from "@chakra-ui/react";

// components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import Select from "components/Select/Select";
import Uploader from "components/Uploader/Uploader";
import UploadSuccessModal from "./Modals/UploadSuccess";

import "pages/styles/dashboard/Account.css";

import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import { useEffect, useState } from "react";

import { uploadFile } from "../../../util/do";
import { useDispatch, useSelector } from "react-redux";
import {
  clearError,
  resetLevel2Form,
  selectAccountVerification,
  updateLevel2Form,
  uploadLevel2Docs,
} from "../../../store/slices/accountVerification.slice";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
// import format from "date-fns/format";

// import SampleIdCard from "assets/png/sample-id-card.png";
import SampleIMG from "assets/png/level3-sample.png";
import { ReactComponent as SelfieSample } from "assets/svg/selfie-verification.svg";

const Button = ({ outlined, children, disabled, ...rest }) => {
  return (
    <ChakraButton
      minW="150px"
      borderRadius="50px"
      color={outlined ? "#03A438" : "white"}
      bg={outlined ? "white" : "#03A438"}
      border={outlined ? "2px solid #03A438" : "none"}
      textTransform="capitalize"
      transition="all 300ms ease-in-out"
      p="10px 20px"
      disabled={disabled}
      _hover={{
        cursor: disabled ? "not-allowed !important" : "pointer",
        boxShadow: "0 0 0 3px #06C3448f, 0 0 10px rgba(0,0,0,.05)",
        transition: "all 300ms ease-in-out",
      }}
      _disabled={{
        opacity: 0.4,
        pointerEvents: "none",
      }}
      {...rest}
    >
      {children}
    </ChakraButton>
  );
};

const StepOne = ({ selectedFile, onFileChange, email }) => {
  return (
    <Box>
      <Stack color="#4E4B66">
        <Text fontSize=".9em" fontWeight="500">
          Step 1:
        </Text>
        <Text fontSize=".9em" fontWeight="500">
          Place your ID card on a piece of paper with this inscription
        </Text>
      </Stack>

      <OrderedList
        m="0"
        mt="24px"
        fontSize=".8em"
        fontWeight="400"
        color="#4E4B66"
      >
        {/* <ListItem>
          Bitmama verification - {email} - {format(new Date(), "dd/MM/yy")}
        </ListItem> */}
        <ListItem>1. Bitmama Verification</ListItem>
        <ListItem>2. Email</ListItem>
        <ListItem>3. Date</ListItem>
      </OrderedList>

      <VStack alignItems="center" w="fit-content">
        {/* <HStack
          mt="14px"
          border="1px solid #EFF0F6"
          bg="#FCFCFC"
          borderRadius="8px"
          p="16px"
          w="fit-content"
        >
          <Image src={SampleIMG} w="173px" h="106px" />

          <Stack ml="20px !important" fontSize=".8em" color="#6E7191">
            <Text>Bitmama Verification</Text>
            <Text>{email}</Text>
            <Text>{format(new Date(), "dd/MM/yy")}</Text>
          </Stack>
        </HStack> */}

        <Image mt="40px" src={SampleIMG} h="calc(100% - 200px)" />

        <Text fontSize=".8em" color="#6E7191" alignSelf="center">
          Recommended upload specification
        </Text>
      </VStack>

      <VStack
        justify="center"
        w="100%"
        p={["26px 0", "26px 0", "26px 0"]}
        gridGap="12px"
      >
        <Uploader
          files={[selectedFile].filter(Boolean)}
          onFiles={(files) =>
            onFileChange({ file: files[0], type: "document" })
          }
        />
        <Text m="0 !important" color="#4E4B66" fontSize=".8em">
          Upload .PDF/.JPG/.JPEG/.PNG file and no more than 5M
        </Text>
      </VStack>
    </Box>
  );
};

const StepTwo = ({ selectedFile, onFileChange }) => {
  return (
    <Box mt="28px">
      <Stack color="#4E4B66">
        <Text fontSize=".9em" fontWeight="500">
          Step 2:
        </Text>
        <Text fontSize=".8em" fontWeight="400">
          Hold ID card close to your face, snap and upload image
        </Text>
      </Stack>

      <VStack alignItems="flex-start">
        <HStack
          mt="14px"
          border="1px solid #EFF0F6"
          bg="#FCFCFC"
          borderRadius="8px"
          p="16px"
          w="100%"
          alignItems="center"
          justifyContent="center"
        >
          <Box as={SelfieSample} />

          {/* <Stack ml="20px !important" fontSize=".8em" color="#6E7191">
            <Text>Bitmama Verification</Text>
            <Text>{email}</Text>
            <Text>{format(new Date(), "dd/MM/yy")}</Text>
          </Stack> */}
        </HStack>

        <Text fontSize=".8em" color="#6E7191" alignSelf="center">
          Recommended upload specification
        </Text>
      </VStack>

      <VStack
        justify="center"
        w="100%"
        p={["26px 0", "26px 0", "26px 0"]}
        gridGap="12px"
      >
        <Uploader
          files={[selectedFile].filter(Boolean)}
          onFiles={(files) => onFileChange({ file: files[0], type: "selfie" })}
        />
        <Text m="0 !important" color="#4E4B66" fontSize=".8em">
          Upload .PDF/.JPG/.JPEG/.PNG file and no more than 5M
        </Text>
      </VStack>
    </Box>
  );
};

const StepThree = ({ selectedFile, onFileChange }) => {
  const {
    // error,
    level2: { category, supportingDocType },
  } = useSelector(selectAccountVerification);
  const dispatch = useDispatch();

  const handleIdTypeChange = (e) => {
    const [, supportingDocType] = String(e.target.value).split("-");
    // console.log("DOC TYPE", category, supportingDocType);
    dispatch(updateLevel2Form({ supportingDocType }));
  };

  const SecondaryIDs = [
    { name: "Work ID", value: "work_id", category: "secondary" },
    { name: "Tax Card", value: "tax_card", category: "secondary" },
    {
      name: "Bank Statement",
      value: "bank_statement",
      category: "secondary",
    },
    {
      name: "School ID Card",
      value: "school_id_card",
      category: "secondary",
    },
    {
      name: "Court Affidavit",
      value: "court_affidavit",
      category: "secondary",
    },
    {
      name: "Birth Certificate",
      value: "birth_certificate",
      category: "secondary",
    },
    {
      name: "Marriage Certificate",
      value: "marriage_certificate",
      category: "secondary",
    },
  ];

  return (
    <Box mt="28px">
      <Stack color="#4E4B66">
        <Text fontSize=".9em" fontWeight="500">
          Step 3:
        </Text>
        <Text fontSize=".8em" fontWeight="400">
          Upload a supporting document (any other ID type). Do not repeat step 1
          & 2 for this supporting document.
        </Text>
      </Stack>

      <FormControl mt="20px" maxW="240px">
        <Select
          label="ID Type"
          placeholder="Select ID Type"
          value={`${category}-${supportingDocType}`}
          onChange={handleIdTypeChange}
        >
          {SecondaryIDs.map((type) => (
            <option
              value={`${type.category}-${type.value}`}
              key={`id-type-${type.value}`}
            >
              {type.name}
            </option>
          ))}
        </Select>
      </FormControl>

      <VStack
        justify="center"
        w="100%"
        p={["26px 0", "26px 0", "26px 0"]}
        gridGap="12px"
      >
        <Uploader
          files={[selectedFile].filter(Boolean)}
          onFiles={(files) =>
            onFileChange({ file: files[0], type: "supportDocument" })
          }
        />
        <Text m="0 !important" color="#4E4B66" fontSize=".8em">
          Upload .PDF/.JPG/.JPEG/.PNG file and no more than 5M
        </Text>
      </VStack>
    </Box>
  );
};

const AccountLevel2PrimaryVerification = (props) => {
  const toast = useToast();
  const { isOpen, onClose, onOpen } = useDisclosure();
  const dispatch = useDispatch();
  const {
    error,
    level2: { category, status, files },
  } = useSelector(selectAccountVerification);

  const userData = props.userData;

  console.log("WER", userData);

  const history = useHistory();

  useEffect(() => {
    if (!category) history.replace("/dashboard/account/verification/level2");
  });

  const [isUploading, setIsUploading] = useState(false);
  const [stepOneFile, setStepOneFile] = useState(files[0]);
  const [stepTwoFile, setStepTwoFile] = useState(files[1]);
  const [stepThreeFile, setStepThreeFile] = useState(files[2]);

  const handlePrimaryUpload = async () => {
    if (!stepOneFile && !stepTwoFile) return;
    setIsUploading(true);
    const toUpload = [];
    [stepOneFile, stepTwoFile].forEach((doc) => {
      const filename = `idDoc_${category}_${doc.type}_${userData.userId}`;
      toUpload.push(uploadFile(doc.file, filename));
    });
    const res = await Promise.all(toUpload);
    const endRes = res.filter(Boolean);
    setIsUploading(false);
    console.log("UPLOADED STEP ONE FILE", endRes);
    if (endRes[0] && endRes[1]) {
      dispatch(
        updateLevel2Form({
          docLink: endRes[0].location,
          individualLink: endRes[1].location,
          // supportingDocLink: endRes[2].location,
          kycLevel: "two",
        })
      );
    }

    dispatch(uploadLevel2Docs());
  };

  const handleSecondaryUpload = async () => {
    if (!stepOneFile && !stepTwoFile && !stepThreeFile) return;
    setIsUploading(true);
    const toUpload = [];
    [stepOneFile, stepTwoFile, stepThreeFile].forEach((doc) => {
      const filename = `idDoc_${category}_${doc.type}_${userData.userId}`;
      toUpload.push(uploadFile(doc.file, filename));
    });
    const res = await Promise.all(toUpload);
    const endRes = res.filter(Boolean);
    setIsUploading(false);
    console.log("UPLOADED STEP ONE FILE", endRes);
    if (endRes[0] && endRes[1] && endRes[2]) {
      dispatch(
        updateLevel2Form({
          docLink: endRes[0].location,
          individualLink: endRes[1].location,
          supportingDocLink: endRes[2].location,
          kycLevel: "two",
        })
      );
    }

    dispatch(uploadLevel2Docs());
  };

  const handleFiles = async () => {
    if (
      category === "secondary" &&
      stepOneFile &&
      stepTwoFile &&
      stepThreeFile
    ) {
      // dispatch(updateLevel2Form({ files: [stepOneFile, stepTwoFile] }));
      // history.push("/dashboard/accountLevel2SupportDocument");
      await handleSecondaryUpload();
    }
    if (category === "primary" && stepOneFile && stepTwoFile) {
      await handlePrimaryUpload();
    }
  };

  useEffect(() => {
    if (error?.hasError && error.message) {
      toast({
        position: "bottom-right",
        // title: "Oops an error occurred",
        description: error.message,
        status: "error",
        duration: 9000,
        isClosable: true,
        onCloseComplete: () => {
          dispatch(clearError());
        },
      });
    }
  }, [error, dispatch, toast]);

  useEffect(() => {
    if (status === "success") {
      onOpen();
    }
  }, [status, onOpen]);

  const isDisabled = () =>
    isUploading || status === "loading" || !(stepOneFile && stepTwoFile);

  console.log(isDisabled());
  console.log("ERROR MESSAGE", error);

  return (
    <Box>
      <ChakraProvider>
        <Sidemenu currentPage="Account" logoutUser={props.logout} />
        <Header />

        <Box as="section">
          <Box
            className="account-container"
            p={["6em 0 !important", "6.5em 1.5em !important"]}
          >
            <Container
              maxW={["100%", "100%", "calc(100% - 15vw)", "calc(100% - 30vw)"]}
              m="0"
              p={[0, 0, "1rem"]}
            >
              <Stack mx={["24px", 0]}>
                <Heading>Verification</Heading>
                <Breadcrumb
                  className="animate__animated animate__fadeInDown"
                  separator={
                    <ArrowForwardIosRoundedIcon
                      style={{ fontSize: ".8em", color: "#6E7191" }}
                    />
                  }
                >
                  <BreadcrumbItem>
                    <BreadcrumbLink to="/dashboard/account">
                      Account
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <BreadcrumbLink to="/dashboard/account/verification">
                      Verification
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <BreadcrumbLink to="/dashboard/account/verification/level2">
                      Level 2
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbItem isCurrentPage pointerEvents="none">
                    <BreadcrumbLink isCurrentPage to="">
                      Upload Documents
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                </Breadcrumb>
              </Stack>

              <Box
                bg="white"
                p={["32px 24px", "32px 24px", "45px 40px"]}
                mt={["24px", "50px"]}
                borderRadius={[0, "8px", "16px"]}
              >
                <Stack gridGap="10px">
                  <Heading color="#14142B" fontSize="1.3em">
                    Verification Steps
                  </Heading>
                </Stack>

                <Box mt="50px" mb={["50px", 0]}>
                  <StepOne
                    selectedFile={files && files[0]}
                    onFileChange={(file) => setStepOneFile(file)}
                    email={userData?.email ?? ""}
                  />

                  <StepTwo
                    selectedFile={files && files[1]}
                    onFileChange={(file) => setStepTwoFile(file)}
                  />

                  {category === "secondary" && (
                    <StepThree
                      // idTypes={}
                      selectedFile={files && files[2]}
                      onFileChange={(file) => setStepThreeFile(file)}
                    />
                  )}
                </Box>

                <HStack w="100%" justify="center" mt="60px" gridGap="20px">
                  <Button
                    disabled={isUploading || status === "loading"}
                    onClick={() => history.goBack()}
                    outlined
                  >
                    Back
                  </Button>
                  {/* <Button onClick={onOpen}>Upload</Button> */}
                  <Button
                    isLoading={isUploading || status === "loading"}
                    disabled={isDisabled()}
                    onClick={handleFiles}
                  >
                    {(isUploading || status === "loading") && (
                      <CircularProgress
                        size="18px"
                        isIndeterminate
                        color="green.300"
                      />
                    )}
                    {/* {!isUploading &&
                      status !== "loading" &&
                      category === "secondary" &&
                      "Continue"} */}
                    {!isUploading && status !== "loading" && "Upload"}
                  </Button>
                </HStack>
              </Box>

              <UploadSuccessModal
                isOpen={isOpen}
                onClose={() => {
                  onClose();
                  dispatch(resetLevel2Form());
                  history.replace("/dashboard/account/verification");
                }}
              />
            </Container>
          </Box>
        </Box>
      </ChakraProvider>
    </Box>
  );
};

export default AccountLevel2PrimaryVerification;
